import { useEffect, useState } from "react";
import { Api } from "../../../helpers/Api";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import CardGrid from "../Components/CardGrid/CardGrid";
import HomePageFooter from "../Components/Footer/HomePageFooter";
import HomePageHeader from "../Components/Header/HomePageHeader";
import LoadingSpinner from "../Components/Spinner/LoadingSpinner"
import dateFormat from '../../../helpers/DateFormate';
import Moment from 'moment';
import './EventDetails.css';
import { Modal } from "react-bootstrap";
import RegisterModal from "../Registration/Modal/RegisterModal";


const config = {

    _poster: (object) => {
        return  object.poster ? <img src={object.poster} alt="cardimg" /> : <img src='../../../../images/cardimg.svg' alt="cardimg" />;
    },
    _0: (object) => {
        return <h2 className="event-name">Other <span style={{ color: 'red' }}>Events</span></h2>;
    },
    _1: (object) => {
        return <h4 className="card-title"> Registration Open | <span style={{ color: '#002147' }}> Event Fee</span> {object.fee ? object.fee : 'free'}</h4>;
    },
    _2: (object) => {
        return object?.last_registration.substr(8, 2);
    },
    _3: (object) => {
        return Moment(object?.last_registration.substr(0, 10)).format(dateFormat.EventDetailDateFormat).substring(3);
    },
    _4: (object) => {
        return object.location == 'Offline' ? <img src='../../../../images/location-icon.svg' alt="offline" /> : <img src='../../../../images/online-icon.svg' alt="online" />
    },
    _5: (object) => {
        return object.location == 'Online' || !object.address_line_1 ? object.location : `${object.address_line_1}`;
    },
    _6: (object) => {
        return `${object.name}`;
    },
    _7: (object) => {
        return `/registration/${object?.id}/new`;
    },
    _8: (object) => {
        return `Register Now`;
    },
    _9: (object) => {
        return `/EventDetail/${object?.id}`;
    },
    _10: (object) => {
        return `View Details`;
    },
}

const EventDetails = () =>{
    const {id} = useParams();
    const handleClose = () => setShow(false);
    const handleShow = () => { setShow(true) };
    const [show, setShow] = useState(false);
    const [otherEventData, setOtherEventData] = useState([]);
    const [data, setData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();

    const loadData = (id) =>{
        let event_type;
        setIsLoading(true);
        Api.call(`/getEventById/${id}`).then(response => {
            event_type = response.event_type; 
            if(!response){
                navigate("/");
            }
            setData(response);  
        })  
            .catch(console.log)
            .finally(() => { 
                Api.call(`/getEventByEventType/${event_type}`).then(response => {
                setOtherEventData(response);})
                setIsLoading(false)
            });  
        }

        const DateFormate = (data,format) =>{
            return Moment(data).format(format);
        } 

        const timeFormate = (data,format) =>{
            return Moment(data,'HHmm').format(format);
        } 

    useEffect(()=>{
        loadData(id);
    },[id]);
    return <>{isLoading ? <LoadingSpinner /> : 
    <><HomePageHeader divDetails={false} BackgroundUrl={'../../../../images/banner.jpg'} />

    {/* mid section */}
    <div className="main-detail-section">
        <div className="container mobile-main-container">
            <div className="inner-main-section">
                <div className="first-detail-section">
                    <div className="inner-content-first">
                        <div className="view-datemonth">
                            <div className="view-date">
                                <h3>{DateFormate(data?.start_date,dateFormat.Day)}</h3>
                            </div>
                            <div className="mobile-month-button">
                                <div className="view-month">
                                    <p>{DateFormate(data?.start_date,dateFormat.fullMonthWithYear)}</p>
                                    <img src={'../../../../images/online-icon.svg'} alt="logo" />
                                    <span>{data?.location}</span>
                                </div>
                                    <button type="button" onClick={()=> navigate(config._7(data))} className="register-button web-register-button">{config._8(data)}</button>
                            </div>
                        </div>

                        <div className='event-detaildata'>
                            <h2>{data?.name}</h2>
                           
                            <p className="para1">{data.rcount !=0 ?<span style={{color:'#007745'}}>Registration Open</span> : <span style={{color:'#E31E25'}}>Registration Closed </span>} &nbsp;| &nbsp; Event Fee 
                                    <span style={{color:'#007745'}}> {data.fee ? data.fee : 'free'}</span>  &nbsp;{ data.total_seats ? '|  Seats Left ' : "" }
                                    {data.total_seats && <span style={{color:'#E31E25'}}> {data.rcount}</span>}</p>
                            <div className="para-button">
                                <p className="para2"><span style={{color:'#E31E25'}}>Last date of Registration</span> - {DateFormate(data?.last_registration,dateFormat.fullDateFormat)} </p>
                                <button type="button" disabled={data.rcount == 0} onClick={()=> handleShow()} className="register-button mobile-register-button">{config._8(data)}</button>
                            </div>
                        </div>
                    </div>  
                </div>

                <div className="second-detail-section">
                    <div className="inner-content-second">
                        <div className="event-type-detail">
                            {data?.organized_by && 
                            <div className="event-organiser">
                                <p><span style={{fontWeight:600,color:'#002147'}}>Organised By</span> - {data?.organized_by}</p>
                            </div>}
                            {data?.event_type && 
                            <div className="event-type">
                                <p><span style={{fontWeight:600,color:'#002147'}}>Event Type</span> - {data?.event_type}</p>
                            </div>}
                        </div>

                        <div className="event-schedule">
                            <div className="event-date">
                                <p><span style={{fontWeight:600}}>Start Date</span> - {DateFormate(data?.start_date,dateFormat.fullDateFormat)} &nbsp; | &nbsp;
                                <span style={{fontWeight:600}}>End Date</span> - {DateFormate(data?.end_date,dateFormat.fullDateFormat)}</p>
                            </div>
                            {data?.event_start_time && <div className="event-time">
                            <p><span style={{fontWeight:600}}>Start Time</span> - {timeFormate(data?.event_start_time,dateFormat.timeFormat12)}  &nbsp;
                                {/* <span style={{fontWeight:600}}>End Time</span> - 02:00 PM */} </p> 
                            </div>}
                        </div>

                    {/* for mobile */}
                        <div className="mobile-event-type-detail">
                            <div className="mobile-event-organiser">
                                <p>Organised By</p>
                                <span>{data?.organized_by}</span>
                            </div>
                            <div className="mobile-event-type">
                                <p>Event Type</p>
                                <span>{data?.event_type}</span>
                            </div>
                        </div>

                        <div className="mobile-event-schedule">
                            <div className="event-start-date">
                                <p>Start Date</p>
                                <span>{DateFormate(data?.start_date,dateFormat.fullDateFormat)}</span>
                            </div>
                            <div className="event-end-date">
                                <p>End Date</p>
                                <span>{DateFormate(data?.end_date,dateFormat.fullDateFormat)}</span>
                            </div>
                        </div>

                        {data?.about && <div className="about-event">
                            <p>{data?.about}</p>
                        </div>}
                    </div>
                </div>
            </div>
        </div>
    </div>
    {/* end */}

    <Modal 
        show={show} 
        onHide={handleClose} 
        centered
      >
            <RegisterModal 
                id={id}
                heading = 'Register for 5th Annual International Conference & Exhibition'
                para = 'Enter the following details for register now'
            />
      </Modal>

    {otherEventData.length !=0 && <CardGrid config={config} data={otherEventData} />}
    <HomePageFooter /></>} 
    </>
}

export default EventDetails;